import { useCallback, useEffect, useState } from "react";
import { ExamSession } from "../../../../types/markTypes";
import { getTeacherExamSessions } from "../../../../services/markService";
import { message } from "antd";

export const useTeacherExamSessions = (teacherId: string) => {
  const [examSessions, setExamSessions] = useState<ExamSession[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });
  const fetchExamSessions = useCallback(async (filters: any) => {
    setIsLoading(true);
    try {
      const response = await getTeacherExamSessions(teacherId, filters);
      setExamSessions(response.data);
      setPagination(response.pagination)
    } catch (err) {
      setError(err as Error);
      message.error("Failed to fetch teacher's exam sessions.");
    } finally {
      setIsLoading(false);
    }
  }, [teacherId]);

  useEffect(() => {
    fetchExamSessions({ page: pagination.page, limit: pagination.limit });
  }, [fetchExamSessions]);

  return { examSessions, isLoading, error, fetchExamSessions, pagination };
};